import api from "./api";

export interface GetClientRequestsResponse {
  clientId: number;
  data: { date: string; count: number }[];
  totalCount: number;
  period: {
    start: string;
    end: string;
  };
}

export interface GetRequestsByTypesResponse {
  data: { type: string; count: number }[];
}

const requestsEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    getRequests: builder.query<GetClientRequestsResponse, number>({
      query: (id) => `request/${id}`,
      providesTags: () => [{ type: "request" }],
    }),
    getRequestByTypes: builder.query<GetRequestsByTypesResponse, number>({
      query: (id) => `request/type/${id}`,
      providesTags: () => [{ type: "request" }],
    }),
  }),
});

export default requestsEndpoints;
export const { useGetRequestsQuery, useGetRequestByTypesQuery } = requestsEndpoints;
